import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import sliderIcon from '../../assets/img/slider-btn.webp';
import {
  DashboardIcon,
  Packages,
  Purchase,
  Receipt,
  Bills,
  Manufacturing,
  Dispatch,
  Reports,
  Logs
} from '../../assets/icons';
import { APPS, HEADING, LOCAL_STORAGE, ROUTES, SCANOPTIONS } from '../../constants';
import { Button } from '../shared';
import { getLocalStorageItem } from '../../utils';
import { PopUpBox } from '../shared';
import SettingsIcon from '../../assets/icons/SettingsIcon';

export const Sidebar = ({ currentDashboardRoute, setCurrentDashboardRoute }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();

  const settingsMenu = [SCANOPTIONS.SCAN_GUN, SCANOPTIONS.CAMERA];

  const [isCameraScan, setIsCameraScan] = useState(() => {
    const storedValue = localStorage.getItem('isCameraScan');
    return storedValue !== null ? storedValue === 'true' : false;
  });

  const [scanType, setScanType] = useState(
    isCameraScan ? SCANOPTIONS.CAMERA : SCANOPTIONS.SCAN_GUN,
  );

  const sidebarOptions = [
    {
      name: 'Dashboard',
      tag: APPS.DASHBOARD,
      icon: DashboardIcon,
      route: ROUTES.DASHBOARD,
    },
    {
      name: 'Orders',
      tag: APPS.PURCHASE,
      icon: Purchase,
      route: ROUTES.PURCHASE_ORDER,
    },
    {
      name: 'Bills',
      tag: APPS.BILL,
      icon: Bills,
      route: ROUTES.BILLS,
    },
    {
      name: 'Receipts',
      tag: APPS.RECEIPT,
      icon: Receipt,
      route: ROUTES.RECEIPT,
    },
    {
      name: 'Manufacturing',
      tag: APPS.MFG,
      icon: Manufacturing,
      route: ROUTES.MANUFACTURING,
    },
    {
      name: 'Process Logs',
      tag: APPS.LOGS,
      icon: Logs,
      route: ROUTES.LOGS,
    },
    {
      name: 'Packages',
      tag: APPS.PACK,
      icon: Packages,
      route: ROUTES.PACKAGE,
    },
    {
      name: 'Dispatch',
      tag: APPS.DISPATCH,
      icon: Dispatch,
      route: ROUTES.DISPATCH,
    },
    {
      name: 'WIP Reports',
      tag: APPS.REPORT_NAME,
      icon: Reports,
      route: ROUTES.REPORTS,
    },
  ];

  const allowedApps = [APPS.DASHBOARD, ...getLocalStorageItem(LOCAL_STORAGE.ALLOWED_APP)];
  const filteredSidebarOptions = sidebarOptions.filter((option) =>
    allowedApps.includes(option.tag),
  );
  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsSettingOpen(false);
    }
  };

  const handleSettings = () => {
    setIsSettingOpen(!isSettingOpen);
  };

  const handleScanType = (type) => {
    type === SCANOPTIONS.CAMERA ? setIsCameraScan(true) : setIsCameraScan(false);
    setScanType(type);
    setIsSettingOpen(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('isCameraScan', isCameraScan);
  }, [isCameraScan]);

  const scanTypeSelector = (
    <div ref={dropdownRef} className="w-100 p-2">
      <h5 className="mb-3 bg-secondary p-2 text-light">{HEADING.SELECT_SCAN_MODE}</h5>
      {settingsMenu.map((item, index) => {
        return (
          <div key={index} className="form-check d-flex align-items-center justify-content-start">
            <input
              className="form-check-input fs-6 me-2"
              type="radio"
              name="flexRadioDefault"
              onChange={() => handleScanType(item)}
              id="flexRadioDefault1"
              checked={scanType === item}
            />
            <label className="form-check-label fs-6" htmlFor="flexRadioDefault1">
              {item}
            </label>
          </div>
        );
      })}
    </div>
  );

  return (
    <>
      <Button
        className={`slider-btn position-absolute d-flex align-items-center justify-content-center d-block bg-white p-1 ${
          showSidebar ? 'open' : ''
        }`}
        clickHandler={toggleSidebar}
        type="button"
        id="toggleButton">
        <img src={sliderIcon} alt="arrow-icon" width="18" height="18" />
      </Button>
      <div
        className={`sidebar-main-view flex-column d-flex align-items-start justify-content-between bg-white ${
          showSidebar ? 'show' : ''
        }`}
        id="MenuSidebarMobileView2">
        <div className="w-100">
          <ul className="ps-0 w-100">
            {filteredSidebarOptions.map((option, index) => (
              <li
                key={index}
                className={`sidebar-list d-flex align-items-center position-relative ${
                  option.route === currentDashboardRoute ? 'active' : ''
                }`}
                onClick={() => {
                  setCurrentDashboardRoute(option.route);
                  navigate(option.route);
                }}>
                <option.icon />
                <span>{option.name}</span>
              </li>
            ))}
          </ul>
        </div>
        {getLocalStorageItem(LOCAL_STORAGE.VENDOR_TYPE) === 'clothing' && <div className="w-100">
          <li
            className={`sidebar-list d-flex align-items-center `}
            onClick={() => handleSettings()}>
            <SettingsIcon />
            <span>{HEADING.SETTINGS}</span>
          </li>
        </div>}
      </div>
      <PopUpBox className={'popup-position'} openPopUpBox={isSettingOpen}>
        {scanTypeSelector}
      </PopUpBox>
    </>
  );
};

Sidebar.propTypes = {
  currentDashboardRoute: PropTypes.string.isRequired,
  setCurrentDashboardRoute: PropTypes.func.isRequired,
};
